export const LocalesActions = {
    UPDATE_LOCALE: 'UPDATE_LOCALE'
};

const locales = ( state = {locale: 'en', messages: {}} , action) => {
    switch (action.type){
        case LocalesActions.UPDATE_LOCALE:
            return {
                locale: action.locale,
                messages: action.messages
            };
        default:
            return state
    }
};

export default locales;